"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { tbReportClicked } from 'Actions/Table/TableToolBarActions';
import { System } from "Constants/objects";

var ReportsButtonProps =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(ReportsButtonProps, _BaseToolbarButtonPro);

  function ReportsButtonProps(_ref) {
    var _this;

    var isContextMenu = _ref.isContextMenu,
        title = _ref.title,
        _ref$items = _ref.items,
        items = _ref$items === void 0 ? [] : _ref$items,
        rest = _objectWithoutProperties(_ref, ["isContextMenu", "title", "items"]);

    _classCallCheck(this, ReportsButtonProps);

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: title,
      hint: title,
      disabled: true,
      elementAttr: {
        'class': System.TOOLBAR_BTN_CLASSES.REPORTS
      },
      items: items
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReportsButtonProps).call(this, props));
    _this._items = items;
    if (isContextMenu) _this.setOptions({
      template: null
    });
    return _this;
  }

  _createClass(ReportsButtonProps, [{
    key: "template",
    value: function template(data, index, element) {
      var menuData = [{
        items: this._items,
        template: function template() {
          return $("<span class=\"icon menu-dpdown\"><i class=\"material-icons\">print</i><span class=\"dx-button-text\">Reports</span><i class=\"fas fa-caret-down\"></i></span>");
        }
      }];
      return $('<div class="custom-dropdown-menu">').dxMenu({
        dataSource: menuData,
        cssClass: "custom-dropdown-menu"
      });
    }
  }]);

  return ReportsButtonProps;
}(BaseToolbarButtonProp);

_defineProperty(ReportsButtonProps, "create", function (options) {
  return new ReportsButtonProps(options).props();
});

export { ReportsButtonProps as default };
;
export var ReportsButtonItemProp =
/*#__PURE__*/
function () {
  function ReportsButtonItemProp(_ref2) {
    var _this2 = this;

    var title = _ref2.title,
        CustomParameters = _ref2.CustomParameters,
        ActionFormID = _ref2.ActionFormID,
        _formUUID = _ref2.formUUID,
        rest = _objectWithoutProperties(_ref2, ["title", "CustomParameters", "ActionFormID", "formUUID"]);

    _classCallCheck(this, ReportsButtonItemProp);

    _defineProperty(this, "onMouseDown", function (_ref3) {
      var actionFormID = _ref3.actionFormID,
          customParameters = _ref3.customParameters,
          UUID = _ref3.UUID;

      if (customParameters) {
        tbReportClicked({
          customParameters: customParameters,
          actionFormID: actionFormID,
          formUUID: UUID
        });
      }
    });

    _defineProperty(this, "template", function (data, index, element) {
      var result = $("<div>").addClass('d5popover-with-list-li');
      if (data.iconSrc) $("<div>").addClass("dx-icon dx-icon-".concat(data.iconSrc)).appendTo(result);
      $("<div>").text(data.text).appendTo(result);
      element.hover(function () {
        $(this).css('background-color', '#f2f2f2');
      }, function () {
        $(this).css('background-color', '');
      });
      $(element).off('click').on('click', _this2.onMouseDown.bind(_this2, data));
      return result.appendTo(element);
    });

    _defineProperty(this, "updateUUID", function (formUUID) {
      _this2._props.UUID = formUUID;
    });

    this._props = _objectSpread({
      text: title,
      elementAttr: {
        'class': "table-form-reports-item"
      },
      template: this.template.bind(this),
      customParameters: CustomParameters,
      actionFormID: ActionFormID,
      UUID: _formUUID,
      updateUUID: this.updateUUID
    }, rest);
  }

  _createClass(ReportsButtonItemProp, [{
    key: "props",
    value: function props() {
      return _objectSpread({}, this._props);
    }
  }]);

  return ReportsButtonItemProp;
}();

_defineProperty(ReportsButtonItemProp, "create", function (options) {
  return new ReportsButtonItemProp(options).props();
});